import { JSONObject } from 'src/graphql.generated'

export type PatientRecordDetails = {
  source: string | null
  employer: string | null
  isDependent: boolean | null
  groupID: string | null
  memberID: string | null
  externalReferenceID: string | null
  referralName: string | null
  referralType: string | null
  excludedFromCalculations: boolean | null
}

const str = (value: unknown): string | null => (typeof value === 'string' ? value : null)
const bool = (value: unknown): boolean | null => (typeof value === 'boolean' ? value : null)

// `Patient.details` is an untyped JSONObject over the wire; this is the only place that reads it.
export const readDetails = (details: JSONObject | null | undefined): PatientRecordDetails => ({
  source: str(details?.source),
  employer: str(details?.employer),
  isDependent: bool(details?.isDependent),
  groupID: str(details?.groupID),
  memberID: str(details?.memberID),
  externalReferenceID: str(details?.externalReferenceID),
  referralName: str(details?.referralName),
  referralType: str(details?.referralType),
  excludedFromCalculations: bool(details?.excludedFromCalculations),
})
